import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { RadioGroupProps } from 'antd';
import { generateOptions } from './helper';

export const generate = (
  props?: Partial<IFormFieldSchema<RadioGroupProps>>
): IFormFieldSchema<RadioGroupProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Radio Group',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormRadioGroup,
    'x-validator': [],
    enum: generateOptions(props),
    'x-component-props': {
      optionType: props?.['x-component-props']?.optionType ?? 'default',
      buttonStyle: props?.['x-component-props']?.buttonStyle ?? 'outline',
      size: props?.['x-component-props']?.size,
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    'x-decorator-props': {},
    'x-decorator-props-config': {},
  };
};
